// extracted by mini-css-extract-plugin
module.exports = {"container":"DevicesTable_container__6CRDE","loadingMinHeight":"DevicesTable_loadingMinHeight__2i2MS","devices":"DevicesTable_devices__3Wfd0","text":"DevicesTable_text__A2aEA"};